<template>
  <element>
    <nav-breadcrumb :menu="[{label: '已授信进件'}, {label: '详情'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-tabs v-model="tabName">
          <template>
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <template>
                <customer-detail-fang-component v-model="customerDetail"/>
              </template>
            </el-tab-pane>
            <el-tab-pane label="抵押房屋" name="House">
              <customer-house-fang-component v-model="customerDetail"/>
            </el-tab-pane>
            <el-tab-pane label="共借人" name="borrower">
              <panel v-for="(item, idx) in customerDetail.coborrowers" :key="idx">
                <el-checkbox true-label="true" false-label="false" :label="'共借人'+(idx+1)" v-model="item.co__checked" disabled></el-checkbox>
                <panel class="zhengjianxinxi"  v-if="item.co__checked">
                <form-build
                  :form-data.sync="item"
                  :form-rules="coRules"
                  :form-columns="coColumns"
                  class="formTable"

                />
                </panel>
                <panel class="zhengjianxinxi" v-if="item.co__checked">
                  <photo-browser v-model="item.co__borrowerICFront" type='image' label="本人身份证正面"/>
                  <photo-browser v-model="item.co__borrowerICBack" type='image' label="本人身份证反面"/>
                    <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="item.co__borrowerHukou1" :editable="false" ></file-upload>户口本</div>
                </panel>
              </panel>
            </el-tab-pane>
            <el-tab-pane  label="收款银行账户" name="bankInfo">
              <panel class="zhengjianxinxi">
                <form-build
                  :form-data.sync="customerDetail"
                  :form-rules="bankRules"
                  :form-columns="bankColumns"
                  class="formTable"
                  form-name="formSubmit4" ref="formBuildName4"
                />
              </panel>
              <panel class="zhengjianxinxi">
                <photo-browser v-model="customerDetail.pic__customerBankCardFront" type='image' label="银行卡正面"/>
              </panel>
            </el-tab-pane>
            <el-tab-pane label="评估审批" name="Approve">
              <el-steps :active="1000" class="step-shenpi">
                <el-step :title="'进件送签'"  :description="$moment(customerDetail.t__createdDate).format('YYYY-MM-DD HH:mm:ss')">
                  <i class="step-start" slot="icon"></i>
                </el-step>
                <el-step v-for="(item, idx) in (customerDetail.approvals||[]).filter(item=>item.a__approvingDate)" class="step-spec" :description="$moment(item.a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(item.a__approvingStatus)" :key="idx" >
                    <i class="step-mid" slot="icon" v-if="item.a__approvalType!='reStart'"></i>
                    <div  v-if="item.a__approvalType!='reStart'" slot="title">{{Status2CN(item.a__nodeName)}} <br />{{item.a__approverName}}</div>
                    <i class="step-start" slot="icon" v-if="item.a__approvalType=='reStart'"></i>
                    <div  v-if="item.a__approvalType=='reStart'" slot="title">{{Status2CN(item.a__nodeName)}} </div>
                </el-step>

                <!--<el-step v-if="approvalListcount>1" class="step-spec" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName"  :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>2" class="step-spec" :title="Status2CN(approvalList[2].a__approvalType)+approvalList[2].a__approverName"  :description="$moment(approvalList[2].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[2].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>3" class="step-spec" :title="Status2CN(approvalList[3].a__approvalType)+approvalList[3].a__approverName"  :description="$moment(approvalList[3].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[3].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>4" class="step-spec" :title="Status2CN(approvalList[4].a__approvalType)+approvalList[4].a__approverName"  :description="$moment(approvalList[4].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[4].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>-->
                <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Approved'" >
                  <i class="step-over" slot="icon"></i>
                </el-step>
                <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Completed'" >
                  <i class="step-over" slot="icon"></i>
                </el-step>
              </el-steps>
              <panel>
                <data-table
                  :table-data="approvalArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
            </el-tab-pane>
           <!-- <el-tab-pane label="还款银行账户" name="Bank">
              <data-table
                :table-data="BankArry"
                :columns="BankColumns"
                :actions="actions"
                :is-pagination-show="false"
              />

              <el-dialog :visible.sync="dialogVisible" :title="dialogTitle">
                <form-build
                  form-name="ConfigDepartmentEditForm"
                  :form-data.sync="form"
                  :form-columns="formColumns"
                  :form-rules="formRules"
                  :form-buttons="formButtons"
                ></form-build>
              </el-dialog>

            </el-tab-pane>-->
          </template>
        </el-tabs>
      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import CustomerDetailFangComponent from '../components/CustomerDetailFangComponent'
  import CustomerHouseFangComponent from '../components/CustomerHouseFangComponent'
  import Panel from "../../components/Panel";
  import DataTableComponent from "../../components/DataTable";
  import FormBuildComponent from "../../components/FormBuild";
  import bankTypeOptions from "../../utils/bankTypeOptions"
  export default {
    name: "CustomerApplyingApproveKF",
    components: {Panel,FormBuildComponent, DataTableComponent},
    data(){
      return {
        bankRules: {
        },
        bankColumns:[
          {
            label: '户名',
            field: 'ba__customerName',
            type: 'text',
          },
          {
            label: '账号',
            field: 'ba__customerBankAccountNo',
          },
          {
            label: '开户银行',
            field: 'ba__customerBankName',
            span:24
          },
        ],
        coRules:{

        },
        coColumns:[
          {
            label: '与借款人关系',
            field: 'co__relationship',
          },
          {
            label: '姓名',
            field: 'co__borrowerName',
          },
          {
            label: '身份证号码',
            field: 'co__borrowerIC',
          },
          {
            label: '手机号',
            field: 'co__borrowerContactNo',
          },
          {
            label: '住所地址',
            field: 'co__borrowerAddress',
            span:24
          },
        ],
        tabName: 'CustomerSummary',
        customerDetail:{
          coborrowers:[]
        },
        approvalListcount:0,
        approvalList:{
        },
        BankList:{

        },
        tableColumns: [
          {
            label: '节点',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作人',
            field: 'approverName'
          },
          {
            label: '操作时间',
            field: 'time',
            formatter: function (r,c,v) {
              return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          },
          {
            label: '操作结果',
            field: 'status'
          }, {
            label: '操作备注',
            field: 'remarks'
          },

        ],
        approvalArry:{
          data:[],
          count:0,
        },
        BankArry:{
          data:[],
          count:0,
        },
        BankColumns: [
/*          {
            label: '账户类型',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },*/
          {
            label: '账号',
            field: 'cb__accountNo'
          },

          {
            label: '户名',
            field: 'cb__accountName'
          },
          {
            label: '开户银行',
            field: 'cb__bank'
          },
          /*{
            label: '备注',
            field: 'remarks'
          },*/
         /* {
            label: '操作',
            opts:[
              {
                label: '编辑',
                class: 'el-icon-edit',
                clickHandler: (index, row) => {
                  this.editItem(index, row)
                },
              },
           ]
          },*/
        ],
        actions: [
          {
            label: '新增',
            class: 'el-icon-plus',
            clickHandler: ()=>{
              this.editItem()
            }
          }
        ],
        formButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler:$refs=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.onSubmit()
                }
              })
            }
          },
          {
            label: '取消',
            // type: 'primary',
            clickHandler:$refs=>{
              this.dialogVisible = false
            }
          }
        ],
        dialogVisible:false,
        form: {
          c__customerId:'',
          cb__accountId:'',
          cb__accountNo: '',
          cb__accountName: '',
          cb__bank: ''
        },
        formRules: {
          cb__accountNo: [
            {
              required: true,
              message: '账号不能为空！'
            }
          ],
          cb__accountName: [
            {
              required: true,
              message: '户名不能为空！'
            }
          ],
          cb__bank: [
            {
              required: true,
              message: '开户银行不能为空！'
            }
          ],
        },
      }
    },
    components: {
      CustomerDetailFangComponent,
      CustomerHouseFangComponent,
    },
    filters:{
      Status2CN
    },
    watch: {
      applicationIdParam: function () {
        this.getApplyingCustomerFang()
      }
    },
    mounted() {
      if(this.applicationIdParam) {
        this.getApplyingCustomerFang()
      }
    },
  props: {
      applicationId: Object,
  },
    computed: {
      applicationIdParam() {
        return this.applicationId || this.$route.query.applicationId || ''
      },
      dialogTitle() {
        return this.form.cb__accountNo  ? '编辑账户' : '新增账户'
      },
      formColumns: {
        get() {
          return [
            {
              label: '账号',
              component: 'el-input',
              field: 'cb__accountNo',
              span: 24,
            },
            {
              label: '户名',
              component: 'el-input',
              field: 'cb__accountName',
              span: 24,
            },
            {
              label: '开户银行',
              component: 'el-select',
              field: 'cb__bank',
              options:bankTypeOptions,
              span: 24,
            }
          ]
        }
      }
    },
    props: {
      applicationId: {
        type: String,
        default: ''
      }
    },
    methods: {
      Status2CN,
      setApproval:function(){
        let arr=[]
        let count =2
        this.approvalArry.data.push(
          {
            node:'进件送签',
            approverName:'System',
            time:this.customerDetail.t__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )
        console.log(this.approvalList)
        for(var i=0;i<this.approvalList.length;i++){
          let name =this.approvalList[i].a__nodeName



          this.approvalArry.data.push(
            {
              node:name,
              approverName:this.approvalList[i].a__approverName,
              time:this.approvalList[i].a__approvingDate,
              status:Status2CN(this.approvalList[i].a__approvingStatus),
              remarks:this.approvalList[i].a__remarks,

            }
          )
          count++


        }
        console.log('**********')
        this.approvalArry.count = count
        let num=0
        console.log(this.bankList)
        this.BankArry.data=[]
        for(var j=0;j<this.bankList.length;j++){
          this.BankArry.data.push(
            {
              cb__accountId:this.bankList[j].cb__accountId,
              cb__accountNo:this.bankList[j].cb__accountNo,
              cb__accountName:this.bankList[j].cb__accountName,
              cb__bank:this.bankList[j].cb__bank,

            }
          )
          num++
        }

        this.BankArry.count = num
       /* console.log(this.approvalArry)*/
      },
      getApplyingCustomerFang : function () {
        xhr.getApplyingCustomerFang({
          't.applicationId': this.applicationIdParam
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.customerDetail = res.data.data

              this.approvalList = res.data.data.approvals
              this.bankList = res.data.data.accounts
              this.approvalListcount = res.data.data.approvals.length
              this.setApproval()
              let interestType =  this.customerDetail.ba__interestType

              if(interestType=='Yearly'){
                interestType =  this.customerDetail.ba__interestRate+"%（年利率）"
              }
              if(interestType=='Daily'){
                interestType =  this.customerDetail.ba__interestRate+"%（日利率）"
              }
              if(interestType=='Monthly'){
                interestType =  this.customerDetail.ba__interestRate+"%（月利率）"
              }
              this.customerDetail.interestType = interestType
                let approvals = []
                for(var i=0;i<this.customerDetail.approvals.length;i++){
                    approvals.push(this.customerDetail.approvals[i])
                    if(this.customerDetail.approvals[i].a__approvalType=='ZJL'&&this.customerDetail.approvals[i].a__approvingStatus=='Approved'&&i<this.customerDetail.approvals.length-1){
                        approvals.push({
                            'a__approvalType':'reStart',
                            'a__approvingDate':this.customerDetail.approvals[i].a__approvingDate,
                            'a__approvingStatus':''
                        })
                    }
                }

            }
          }catch(e){}
        })
      },
      editItem(index, row) {
        if(typeof row == 'object') {
          this.form = Object.assign({}, row)
        }
        else {
          this.form = {
            c__customerId:'',
            cb__accountId:'',
            cb__accountNo: '',
            cb__accountName: '',
            cb__bank: ''
          }
        }

        this.dialogVisible = true
      },
      onSubmit:function () {
        this.form.c__customerId=this.customerDetail.t__customerId
        this.form.c__checked = true
        xhr.updateBank(
          this.form,
          res=>{
            try {
              if(res.data.status == 'success') {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                this.dialogVisible = false
                this.getApplyingCustomerFang()
              }
              else {
                this.$message({
                  type: 'error',
                  message: '保存失败！'
                })
              }
            }catch (e) {

            }
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerView.vue